import Vue from 'vue';
import VueRouter from 'vue-router';
import { AppConstantPlugin } from 'library/plugins/appConstants/index';

import OrganizationPage from './OrganizationPage.vue';
import OrgViewRetired from './OrgViewRetired.vue';

import tracing from 'library/helpers/tracing';

tracing('OrgView');

Vue.use(AppConstantPlugin);
Vue.use(VueRouter);

const retiredRoutes = [
  { name: 'team-overview', path: '/overview' },
  { name: 'player-outlook', path: '/player-outlook' },
  { name: 'ml-team', path: '/ml-team' },
  { name: 'financial', path: '/financial' },
  { name: 'future-proj', path: '/future-projections' },
  { name: 'team-outlook', path: '/team-outlook' },
  { name: 'pro-looks', path: '/pro-looks' },
  { name: 'perf-hitters', path: '/performance-hitters' },
  { name: 'perf-pitchers', path: '/performance-pitchers' },
  { name: 'def-by-pos', path: '/defense-by-pos' },
  { name: 'proj-value', path: '/projections-and-value' },
  { name: 'industry', path: '/industry' },
  { name: 'long-grid', path: '/longitudinal-grid' },
  { name: 'contracts', path: '/contracts' },
  { name: 'scout-fx-trends', path: '/scout-fx-trends' },
  { name: 'affiliate-perf', path: '/affiliate-performance' },
  { name: 'conversations', path: '/conversations' },
].map((route) => ({
  ...route,
  component: OrgViewRetired,
}));

const routes = [{ path: '/', redirect: '/overview' }, ...retiredRoutes];

const router = new VueRouter({
  base: '/dv/orgs',
  routes,
  mode: 'history',
});

const app = new Vue({
  router,
  render: (h) => h(OrganizationPage),
}).$mount('#org-page');
